<script lang="ts">
  import { onMount } from "svelte";
  import { fetchCurrentUser } from "../auth";
  import { desktopApiKeyFlag } from "../desktop-flag";
  import LoginForm from "./LoginForm.svelte";

  let loggedOut = $state(false);
  let error = $state("");

  onMount(async () => {
    let user;
    try {
      user = await fetchCurrentUser();
    } catch (e) {
      error = e instanceof Error ? e.message : String(e);
      return;
    }
    if (user) {
      location.assign("/account/api-key?new=1");
      return;
    }
    try {
      localStorage.setItem(desktopApiKeyFlag, String(Date.now()));
    } catch {
      // Blocked storage must not hide the login form.
    }
    loggedOut = true;
  });
</script>

<main class="min-h-screen bg-[#f7f7f4] px-4 py-10 text-sm text-gray-900 dark:bg-gray-950 dark:text-gray-100">
  <div class="mx-auto w-[min(420px,calc(100vw-2rem))] rounded-lg bg-white p-6 dark:bg-gray-900">
    {#if error}
      <div class="rounded border border-red-200 bg-red-50 px-3 py-2 text-red-700">{error}</div>
    {:else if loggedOut}
      <p class="mb-5">Log in, then paste the key into SumatraPDF.</p>
      <LoginForm />
    {/if}
  </div>
</main>
